/* global G */
/* eslint-disable no-use-before-define,no-param-reassign */
import { curry } from 'lib/util'

/**
 *
 * @param module
 * @param component
 * @returns {*}
 */
const provideEvents = (module, component) => {
  const events = component[G.CONFIGURATION].options && component[G.CONFIGURATION].options.events
  const moduleEvents = module[G.EVENTS]
  if (events && moduleEvents) {
    const { key } = component[G.CONFIGURATION].options || {}
    component[G.EVENTS] = {}
    Object.keys(events).forEach((name) => {
      const handlerName = events[name]
      const handlerExists = moduleEvents[name]
        && Object.prototype.hasOwnProperty.call(moduleEvents[name], handlerName)
      // todo: turn into pipe(hasNamespace, usesNamespace)
      handlerExists
      && (component[G.EVENTS][name] = {})
      && (component[G.EVENTS][name] = moduleEvents[name][handlerName](module, component))
      !handlerExists && console.warn(
        `Missing event handler '${handlerName}' for '${name}' event trigger in '${key}' component.`,
      )
    })
  }
  return component
}

export default curry(provideEvents)
